module.exports = __webpack_public_path__ + "static/media/netflixMessage.d7fcc9e6.jpg";